import {addDays, format, getDay, subDays} from 'date-fns';
import {sortBy, uniqBy} from 'lodash';

import {ProductDbModel} from '../../../customGraphQlModels/ProductDbModel';
import {
  ProductRecipeCollectionModel,
  RecipeCollectionModel,
} from '../../../customGraphQlModels/ProductRecipeCollectionModel';
import RecipeCarouselV2ContentModel from '../RecipeCarouselV2ContentModel';

export interface CarouselV2Week {
  id: string;
  label: string;
  deliveryDate: Date;
}

const SUNDAY = 0;
const TUESDAY = 2;

// Deliveries run Fri-Mon around the week's Sunday; Backbone weeks are keyed by that Sunday.
export const toDeliveryWeekId = (deliveryDate: Date | string): string => {
  const date = new Date(deliveryDate);
  const day = getDay(date);
  const sunday = day <= TUESDAY ? subDays(date, day - SUNDAY) : addDays(date, 7 - day);

  return format(sunday, "'W'yyyy-MM-dd");
};

const hasRecipes = (entry: ProductRecipeCollectionModel) => entry.collections.some(c => c.recipes.length > 0);

export const getRecipeCarouselV2Collections = (product?: ProductDbModel): Array<RecipeCollectionModel> => {
  const entries = product?.recipeCollections ?? [];
  const upcoming = entries[1];
  const chosen = upcoming && hasRecipes(upcoming) ? upcoming : entries.find(hasRecipes);

  return chosen?.collections.filter(c => c.recipes.length > 0) ?? [];
};

export const getRecipeCarouselV2Weeks = (product?: ProductDbModel): Array<CarouselV2Week> => {
  const sorted = sortBy(getRecipeCarouselV2Collections(product), c => new Date(c.date).getTime());

  return uniqBy(
    sorted.map(c => ({id: toDeliveryWeekId(c.date), label: c.day, deliveryDate: new Date(c.date)})),
    w => w.id
  );
};

export const getRecipeCarouselV2Week = (product?: ProductDbModel): CarouselV2Week | undefined =>
  getRecipeCarouselV2Weeks(product)[0];

export const resolveRecipeCarouselV2Sku = (
  selectedItemNumber: string | undefined,
  carousel?: RecipeCarouselV2ContentModel
): string | undefined => carousel?.productSku || selectedItemNumber;
